/**
 * Enrich the chart of accounts with the associated chart of account and the associated entity
 * @param {Object[]} chartOfAccounts: updates in place
 * @param {Object[]} associatedChartOfAccounts
 * @param {Object} browserAppAccount
 * @returns
 */
export function enrichChartOfAccounts (chartOfAccounts, associatedChartOfAccounts, browserAppAccount) {
  console.log('enrichChartOfAccounts', chartOfAccounts, associatedChartOfAccounts, browserAppAccount)
  const associatedChartOfAccountsMap = new Map(associatedChartOfAccounts.map(d => [d.accounting_chart_of_account_id, d]))

  chartOfAccounts.forEach(function (chartOfAccount) {
    const associatedChartOfAccount = associatedChartOfAccountsMap.get(chartOfAccount.id)
    chartOfAccount.isGroupAccount = associatedChartOfAccount !== undefined
    chartOfAccount.associatedChartOfAccount = associatedChartOfAccount || null

    chartOfAccount.associatedEntity = null
    if (chartOfAccount.associatedChartOfAccount) {
      chartOfAccount.associatedEntity = browserAppAccount.data.entities.find(e => e.id === chartOfAccount.associatedChartOfAccount.representing_accounting_organisation_id)
    }
  })
  return chartOfAccounts
}
